import {UPDATE_POLICY_PAYLOAD, UPDATE_POLICY_PAYLOAD_ERROR, UPDATE_POLICY_PAYLOAD_RESET, UPDATE_POLICY_PAYLOAD_SUCCESS} from '../actionTypes';


export const policy = (policy) => {
    return ({
        type: UPDATE_POLICY_PAYLOAD,
        payload: {policy}
    })
}
  
  export const policySuccess = (data) => ({
    type: UPDATE_POLICY_PAYLOAD_SUCCESS,
    payload: data,
  });
  
  export const policyReset = () => ({
    type: UPDATE_POLICY_PAYLOAD_RESET,
  });
  
  export const policyError = (error) => ({
    type: UPDATE_POLICY_PAYLOAD_ERROR,
    payload: error,
  });